import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const TestInfo = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M8 5.333A.667.667 0 1 0 8 4a.667.667 0 0 0 0 1.333ZM6 6.667l.4 1.266.8-.333-.533 3.6c-.067.467.4.867.866.733l2-.666-.4-1.267-1 .333.534-3.533c.066-.467-.4-.867-.867-.733l-1.8.6Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="m9.51 1.959 4.531 4.53a2.136 2.136 0 0 1 0 3.021l-4.53 4.531a2.136 2.136 0 0 1-3.021 0l-4.531-4.53a2.136 2.136 0 0 1 0-3.021l4.53-4.531a2.136 2.136 0 0 1 3.021 0Zm-.942.943a.802.802 0 0 0-1.135 0l-4.531 4.53a.803.803 0 0 0 0 1.135l4.53 4.531a.803.803 0 0 0 1.136 0l4.53-4.53a.803.803 0 0 0 0-1.136l-4.53-4.53Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default TestInfo;
